"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreSonarObjectsOptimisticReducers = void 0;
const add_1 = require("./add.js");
const remove_1 = require("./remove.js");
const state_1 = require("./state.js");
const xuder_1 = require("@sonar-software/xuder");
exports.coreSonarObjectsOptimisticReducers = (0, xuder_1.joinSyncReducers)([add_1.coreSonarObjectsOptimisticChangeAddSlice.syncReducer, remove_1.coreSonarObjectsOptimisticChangeRemoveSlice.syncReducer], state_1.defaultSonarObjectsOptimisticChangeState);
//# sourceMappingURL=index.js.map